import * as THREE from "three";
import React, { memo, useEffect, useState } from "react";
import { Line } from "../shape/Line";

const MBox = memo(({ color, mesh, redrawBox }) => {
  const objects       = [];

  //console.log('redrawBox = ', redrawBox)

  if ( mesh != null ) {
    mesh.geometry.computeBoundingBox();
    const b = new THREE.Box3();
    b.copy( mesh.geometry.boundingBox ).applyMatrix4( mesh.matrixWorld );

    const vp1 = [
      new THREE.Vector3(b.min.x, b.min.y, b.max.z),
      new THREE.Vector3(b.min.x, b.max.y, b.max.z),
      new THREE.Vector3(b.max.x, b.max.y, b.max.z),
      new THREE.Vector3(b.max.x, b.min.y, b.max.z),
      new THREE.Vector3(b.min.x, b.min.y, b.max.z)
    ];
    const vp2 = [
      new THREE.Vector3(b.min.x, b.min.y, b.min.z),
      new THREE.Vector3(b.min.x, b.max.y, b.min.z),
      new THREE.Vector3(b.max.x, b.max.y, b.min.z),
      new THREE.Vector3(b.max.x, b.min.y, b.min.z),
      new THREE.Vector3(b.min.x, b.min.y, b.min.z)
    ];
    const vp3 = [
      new THREE.Vector3(b.min.x, b.min.y, b.min.z),
      new THREE.Vector3(b.min.x, b.min.y, b.max.z)
    ];
    const vp4 = [
      new THREE.Vector3(b.max.x, b.min.y, b.min.z),
      new THREE.Vector3(b.max.x, b.min.y, b.max.z)
    ];
    const vp5 = [
      new THREE.Vector3(b.min.x, b.max.y, b.min.z),
      new THREE.Vector3(b.min.x, b.max.y, b.max.z)
    ];
    const vp6 = [
      new THREE.Vector3(b.max.x, b.max.y, b.min.z),
      new THREE.Vector3(b.max.x, b.max.y, b.max.z)
    ];

    objects.push(<Line key={1} vpoints={vp1} color={color} />);
    objects.push(<Line key={2} vpoints={vp2} color={color} />);
    objects.push(<Line key={3} vpoints={vp3} color={color} />);
    objects.push(<Line key={4} vpoints={vp4} color={color} />);
    objects.push(<Line key={5} vpoints={vp5} color={color} />);
    objects.push(<Line key={6} vpoints={vp6} color={color} />);
  }

  return objects.length !== 0 ? (
    <React.Fragment>
      {objects}
    </React.Fragment>
  ) : null;
});

export default MBox;
